<template>
    <div>
        <label>{{ label }}</label>
        <VueDatePicker v-model="localValue" :name="name" time-picker :is-24="true" model-type="HH:mm" format="HH:mm"
            :locale="locale" :clearable="true" teleport="body" :placeholder="placeholder"
            :select-text="$t('common.select')" :cancel-text="$t('common.cancel')" :state="error ? false : null"
            @update:model-value="onChange" />
        <!-- Hidden input carries the HH:mm value so collectFormData submits a browser-independent value -->
        <input type="hidden" :name="name" :value="localValue || ''" />
    </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import { useI18n } from 'vue-i18n';

export default {
    components: {
        VueDatePicker
    },
    setup() {
        const { locale } = useI18n();
        return { locale };
    },
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        // See InputDate: the root is a wrapper div, so this goes to
        // VueDatePicker's `state` rather than a class on the root.
        error: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localValue: this.value || null
        };
    },
    watch: {
        value(newVal) {
            this.localValue = newVal || null;
        }
    },
    methods: {
        onChange(val) {
            this.localValue = val || null;
            this.$emit('update:value', val || '');
        }
    }
};
</script>

<style scoped>
/* Make VueDatePicker's input visually match the plain native inputs (InputText / InputDate) on the same row */
:deep(.dp__main) {
    display: inline-block;
    vertical-align: middle;
    width: 130px;
    margin-right: 5px;
}

:deep(.dp__input_wrap) {
    display: block;
}

:deep(.dp__input) {
    height: auto;
    min-height: 0;
    line-height: normal;
    padding: 1px 2px;
    border: 1px solid var(--bs-border-color);
    border-radius: 2px;
    font-family: inherit;
    font-size: inherit;
    color: inherit;
}

/* The library's own .dp__input_invalid only sets border-color, which the border
   shorthand above outranks -- same specificity, but it wins on order. Restating
   it here, after that rule, is what actually makes the red border appear. */
:deep(.dp__input_invalid) {
    border-color: var(--dp-danger-color);
    box-shadow: 0 0 var(--dp-border-radius) var(--dp-danger-color);
}

/* Hide the clock icon so the field lines up with the icon-less native inputs */
:deep(.dp__input_icon) {
    display: none;
}

:deep(.dp__input_icon_pad) {
    padding-left: 2px;
}
</style>
